import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectChildEventAndContinue, setSelectedChildEvent, setSelectedDate, setEventTimes, setSelectedEventTimeObject } from '../../series/actions/event-series';
import { hourMinute } from '@showclix-shared-intl/dateTimeFormatters';
import { isValidDateObject } from '../../../../helpers/time';
import { removeListingItem } from '../../../../listing/helpers/storage';
import { getSeriesConfig } from '../../../selectors/ui';
import { getNextAvailableEventTodayTime, getNextAvailableEventTodayId, getNextAvailableEventTodayInventory, getNextAvailableEventToday } from '../selectors/eventSeries';
import { getLowInventoryMessage } from '../selectors/eventSeries';
import Button from '@s/Button';
import { TranslationContext } from '../../../../checkout/config/Translations';

class NextAvailableTimeButton extends Component {

    onClick = () => {
        if (this.props.nextAvailableEventTime && this.props.nextAvailableEventId) {
            //clear previously populated data
            removeListingItem(this.props.listingSlug, 'selectedEventId');

            this.props.setSelectedDate(this.props.nextAvailableEventTime).then(() => {
                if (this.props.nextAvailableEvent) {
                    this.props.setSelectedEventTimeObject(this.props.nextAvailableEvent);
                }
                this.props.setSelectedChildEvent(this.props.nextAvailableEventId);
                this.props.selectChildEventAndContinue(this.props.nextAvailableEventId);
                this.props.setEventTimes([]);
            });
        }
    }

    render() {
        if (!isValidDateObject(this.props.nextAvailableEventTime) || !this.props.nextAvailableEventId) {
            return null;
        }

        return (
          <TranslationContext.Consumer>
            {translation =>
            <Button onClick={ this.onClick } className="button--primary next-avaliable" loading={this.props.nextAvailableEventLoading}>
                <div className="next-avaliable__text">
                    <span className="next-avaliable__title">{translation.t('checkout__next_available')}</span>
                    <span className="next-avaliable__time">{translation.t('checkout__today_at_time', { time: hourMinute(this.props.locale, this.props.nextAvailableEventTime)})}</span>
                    {this.props.getLowInventoryMessage(this.props.nextAvailableEventInventory, translation) && <span className="next-avaliable__remaining">{this.props.getLowInventoryMessage(this.props.nextAvailableEventInventory, translation)}</span>}
                </div>
                <i className="next-avaliable__arrow icon-navigate_next" aria-hidden="true"></i>
            </Button>
            }
          </TranslationContext.Consumer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        eventTimes: state.eventSeries.eventTimes,
        locale: state.intl.locale,
        listingSlug: state.ui.listingSlug,
        nextAvailableEvent: getNextAvailableEventToday(state),
        nextAvailableEventTime: getNextAvailableEventTodayTime(state),
        nextAvailableEventId: getNextAvailableEventTodayId(state),
        nextAvailableEventInventory: getNextAvailableEventTodayInventory(state),
        getLowInventoryMessage: getLowInventoryMessage(state),
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        selectChildEventAndContinue,
        setEventTimes,
        setSelectedDate,
        setSelectedChildEvent,
        setSelectedEventTimeObject,
    }, dispatch);
};

NextAvailableTimeButton.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(NextAvailableTimeButton)
